<template>
    <div v-if="isVisible" class="tsw-weixin-guide-mask weixin-guide-container" @touchmove.prevent @click="showGuide">
        <!-- <img src="" alt=""> -->
    </div>
</template>

<script>
export default {
    name: "wxGuide",
    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        showGuide() {
            this.isVisible = !this.isVisible;
        }
    }
};
</script>

<style lang="scss" scoped>
.weixin-guide-container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    text-align: center;
    background: rgba(0, 0, 0, 0.8) url(../../assets/image/mask.png) no-repeat;
    background-size: 100%;
}
// .weixin-guide-container img {
//     width: 100%;
//     height: 100%;
// }
</style>
